import React from 'react';
import { FiInbox } from 'react-icons/fi';

/**
 * InboxIcon
 * Ikona priečinka prijatej pošty na zobrazenie prázdnych stavov.
 */
const InboxIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <FiInbox className={className} {...props} />
);

export default InboxIcon;

